module.exports = __webpack_public_path__ + "img/dot.dd57f0e4.png";